import axios from 'axios';
import { toast } from "react-toastify";
import { updateCoordinates } from '@util/config';
import { setAuthHeader } from './axiosApi';
import axiosApi from './axiosApi';
import { safeLocalStorage } from "@utils/localstorage";
import Router from 'next/router';
const today = new Date();
const currentTime = today.toUTCString()
const basicAuth = {
  username: process.env.NEXT_PUBLIC_USERNAME,
  password: process.env.NEXT_PUBLIC_PASSWORD,
}

export const createAccountToken = async (userData, verifierId) => {
  try {
    const resp = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/auth/login`, userData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    resp.data.user.wallet_address = userData.user?.wallet_address;
    const data = resp.data;
    safeLocalStorage.setItem('token', data);
    let token = safeLocalStorage.getItem('token');
    resp.data.user.wallet_address = token.user?.wallet_address;
    safeLocalStorage.setItem('loginToken', data?.token);
    setAuthHeader(data?.token)
    return resp;
  } catch (err) {
    // Only register when login confirms the user does not exist (404).
    // Other failures (401 invalid token / public_key mismatch, 5xx, network)
    // must NOT silently create a duplicate account (PR #1238).
    if (err?.response?.status !== 404) {
      console.error('Login failed (non-404), not registering:', err);
      throw err;
    }
    const mergeData = {
      ...userData,
      user: {
        ...userData.user,
        discord_id: verifierId
      }
    };
    // Use NEXT_PUBLIC_API_URL (not the legacy GATSBY_API_URL — Next.js doesn't
    // expose GATSBY_* to the client bundle, so the previous code silently
    // broke on the flatten).
    const resp = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/auth/register`, mergeData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    resp.data.user.wallet_address = userData.user?.wallet_address;
    const data = resp.data;
    safeLocalStorage.setItem('token', data);
    return resp;
  }
};

export const updateUserAccountData = async (userData) => {
  const user = safeLocalStorage.getItem('token');
  try {
    const resp = await axiosApi({
      method: 'patch',
      url: `/users/me`,
      data: userData,
    })
    user.user.avatar_url = userData.user.avatar_url;
    safeLocalStorage.setItem('token', user);
    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export const paymentIntent = async (userData) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/payments`,
      data: userData
    })
    return resp
  } catch (err) {
    console.error(err);
  }
}

export const saveTransaction = async (transactionId, walletId, TC_amount) => {
  const user = safeLocalStorage.getItem('token');
  try {
    await axios.get(`https://mission-completion.frbts.com/transaction/${transactionId}/${walletId}/${TC_amount}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
      }
    });
    // axios.get(`https://mission-completion.frbts.com/nfts/new_mint`, {});
  } catch (err) {
    console.error(err);
  }
}

/**
 * Get a list of bots that are online.
 *
 * Online bots are bots that are in `mission_ready`, `test_ready`, or `mission_in_progress` status.
 */
export const getBotDetails = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots`,
    });
    const bots = res?.data?.bots;
    if (!Array.isArray(bots)) {
      return null;
    }
    const updatedData = updateCoordinates(bots);
    return updatedData;
  } catch (err) {
    console.log({ err });
    return null;
  }
};

export const createTransaction = async (userData) => {
  safeLocalStorage.setItem('referenceCode', userData.transaction.reference_code)
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/transactions`,
      data: userData
    })
    safeLocalStorage.setItem(`transaction_id_${resp.data.transaction.id}`, resp.data.transaction.status);
    return resp?.data
  } catch (err) {
    console.error(err);
  }
}

export const mintingCallback = async (reference_code, transactionId, status) => {
  const user = safeLocalStorage.getItem('token');
  const transactionStatus = {
    "transaction": {
      "status": status,
      reference_code: reference_code
    }
  }
  try {
    const resp = await axiosApi({
      method: 'put',
      url: `/transactions/${transactionId}`,
      data: transactionStatus
    })
    safeLocalStorage.setItem(`transaction_id_${transactionId}`, status)
    await saveTransaction(reference_code, user?.user?.wallet_address, 10)
    return resp.data
  } catch (err) {
    console.error(err);
  }
};

export const createRide = async (matchMissionData) => {
  const currentDayTime = new Date();
  const currentRideTime = currentDayTime.toUTCString();
  const rideData = {
    ride: {
      mission_id: matchMissionData?.id,
      start_time: currentRideTime,
      time_credit: matchMissionData?.time_credit
    }
  }

  const resp = await axiosApi({
    method: 'post',
    url: `/rides`,
    data: rideData
  })
  return resp;
}

export const getMissions = async (missionBotId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots/${missionBotId}/missions`,
    })
    return res;
  } catch (err) {
    if (err.response) {
      toast.error(`Something went wrong. Please try again.`, { position: "top-right" });
      return err.response
    }
  }
}

export const minusRideSession = async (num) => {
  const drivingBot = safeLocalStorage.getItem('drivingBot')
  const minusTime = {
    ride_session: {
      append_metadata_rides: {
        current_time: currentTime,
        ride_sequence: num
      }
    }
  }

  const session_id = safeLocalStorage.getItem(`sessionId_${drivingBot?.deviceId}`);
  try {
    if (session_id) {
      const resp = await axiosApi({
        method: 'put',
        url: `/ride_sessions/${session_id}`,
        data: minusTime
      })
      return resp
    }
  } catch (err) {
    console.log('err: ', err);
  }
}

export const checkpointReached = async (sequence, rideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides/${rideId}/checkpoint_reached`,
      data: sequence
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const createRideSession = async () => {
  const drivingBot = safeLocalStorage.getItem('drivingBot')
  const new_rideSession = {
    ride_session: {
      status: "active",
      start_time: currentTime,
      metadata: {
        "rides": [{
          current_time: currentTime,
          ride_sequence: 1
        }]
      }
    }
  }

  const rideId = await safeLocalStorage.getItem(`rideId_${drivingBot?.deviceId}`)

  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides/${rideId}/ride_sessions`,
      data: new_rideSession
    })
    return resp;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getUserDetails = async () => {
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/users/me`,
    })
    return resp;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getShuftiProToken = async () => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/kyc`,
      data: {}
    })
    const data = resp.data;
    return data.access_token;
  } catch (error) {
    console.error('Error getting ShuftiPro token:', error);
    throw error;
  }
};


export const updateFeedBack = async (feedback, rideId) => {
  try {
    const resp = await axiosApi({
      method: 'put',
      url: `/rides/${rideId}`,
      data: feedback
    })
    return resp;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getFeedBackByMission = async (missionId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/missions/${missionId}/feedbacks`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const rideTerminate = async (rideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides/${rideId}/terminate`,
      data: {}
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getStatusRide = async (rideId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/rides/${rideId}`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getGamePlay = async (fullLicenceExperiencePoint) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots/available?level=${fullLicenceExperiencePoint}`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const ownerManagedBotDetails = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/users/me/managed_bots`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getAgoraToken = async (deviceId, rideId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots/agora_token?bot[device_ref_id]=${deviceId}`,
    })
    return res.data;
  } catch (err) {
    if (err.response) {
      toast.error(`${err.response.data.error}`, { position: "top-right" });
      rideTerminate(rideId)
      toast.error('Your ride is terminate.', { position: "top-right" });
      safeLocalStorage.removeItem(`sessionId_${deviceId}`)
      safeLocalStorage.removeItem(`rideId_${deviceId}`)
      safeLocalStorage.removeItem(`ride_${deviceId}`)
      safeLocalStorage.removeItem(`ride_sequence_${deviceId}`)
      await new Promise(resolve => setTimeout(resolve, 4000));
      safeLocalStorage.removeItem(`drivingBot`)
      Router.push("/dashboard");
    }
  }
}

export const spetategamePaymentRecive = async (queryParams) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/payments`,
      data: queryParams
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const createRidePlay = async (rideData) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides`,
      data: rideData
    })
    return resp.data;
  } catch (error) {
    if (error.response) {
      return error.response.data
    }
  }
}

export const uploadScreenShotCamera = async (data, config) => {
  try {
    const resp = await axios.post(`https://frodobots-image-api.onrender.com/upload`, data, config);
    return resp.data;
  } catch (error) {
    if (error.response) {
      return error.response.data
    }
  }
}

export const gptCheckPoint = async (imagePath, testDriveRideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides/${testDriveRideId}/scan_checkpoints`,
      data: imagePath
    })
    return resp;
  } catch (error) {
    if (error.response) {
      return error.response
    }
  }
}

export const botspectate = async (botId) => {
  const id_Token = safeLocalStorage.getItem('id_Token');
  const user = safeLocalStorage.getItem('token');
  try {
    let res = await axios.get(`${process.env.NEXT_PUBLIC_API_URL}/int/bots/${botId}/spectate`, {
      auth: basicAuth,
      headers: {
        'Content-Type': 'application/json',
        'ID-Token': id_Token,
      }
    });
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getAge = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/kyc/age`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getSuspiciousActivity = async (rideId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/rides/${rideId}/ride_event`,
    })
    return res.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const getPenalties = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/penalties`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const createEpochRides = async (epochRideData) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/epoch_rides`,
      data: epochRideData
    })
    return resp.data;
  } catch (error) {
    console.log('error: ', error);
  }
};

export const showEpochRides = async (id) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/epoch_rides/${id}`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const stopEpochRides = async (id) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/epoch_rides/${id}/end`,
      data: {}
    })
    return resp.data;
  } catch (error) {
    console.log('error: ', error);
  }
};

export const getTotalQualifiedMiles = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/total_qualified_miles`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getUnscoredDriveData = async (deviceId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/epoch_rides?bot[device_ref_id]=${deviceId}&status=unscored`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getUserDrivesData = async (status) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/epoch_rides_with_driver_rides?status=${status}`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getScoredDriveData = async (deviceId) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/epoch_rides?bot[device_ref_id]=${deviceId}&status=scored`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createBotAccessInvitation = async (device_ref_id) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/owners/bot_access_invitations?bot_access_invitation[device_ref_id]=${device_ref_id}`,
      data: ''
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const acceptBotAccessInvitation = async (bot_access_invitation_token) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/users/bot_access_invitations/accept?bot_access_invitation[access_token]=${bot_access_invitation_token}`,
      data: ''
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const sentBotAccessInvitationData = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/bot_access_invitations/sent`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const receivedBotAccessInvitationData = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/users/bot_access_invitations/received`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const shareRideBotAccessInvitation = async (shareRideData) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/rides/shared`,
      data: shareRideData
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const rovokeRideBotAccessInvitation = async (bot_access_invitation_token) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/owners/bot_access_invitations/revoke?bot_access_invitation[access_token]=${bot_access_invitation_token}`,
      data: ''
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createScavengerDrops = async (rideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/scavenger_drops`,
      data: { ride_id: rideId }
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createLargeScavengerDrops = async (rideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/scavenger_drops/create_large`,
      data: { ride_id: rideId }
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getScavengerDrops = async (ride_id) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/scavenger_drops`,
      params: {
        ride_id: ride_id,
      },
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createScavengerDropsReached = async (id, payload) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/scavenger_drops/${id}/reached`,
      data: payload
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const tournamentGames = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/tournament_games`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const tournamentGamesSelectId = async (id) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/tournament_games/${id}`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const tournamentGamesJoin = async (id) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/tournament_games/${id}/join`,
      data: ''
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createTestDriveActivationCode = async (activationCode) => {
  try {
    const activationCodeSet = new Set([activationCode]);
    const formData = new URLSearchParams();
    activationCodeSet.forEach(code => formData.append('activation_code', code));

    const resp = await axiosApi({
      method: 'post',
      url: `/users/activate_code`,
      data: { activation_code: activationCode }
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getSavedBots = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots/saved_bots`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createSavedBots = async (id) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/bots/${id}/save_bot`,
      data: ''
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}
export const xpDetailsScore = async (id) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/missions/${id}/xp_details_score`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const xpleaderboard = async (option) => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/users/xp_leaderboard`,
      params: {
        filter: option,
      },
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getScavengerItems = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/owners/scavenger_items`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const getQuests = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/int/quests`,
      auth: basicAuth,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const createMissionDrops = async (rideId) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/scavenger_drops/mission_distribution`,
      data: { ride_id: rideId }
    })
    return resp.data;
  } catch (err) {
    console.log('err: ', err);
    if (err.response) {
      return err.response.data
    }
  }
}

export const avaliableForSam = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('token'));
    const id_Token = safeLocalStorage.getItem('id_Token');
    const resp = await axiosApi({
      method: 'get',
      url: `/int/bots/available_for_sam`,
      auth: basicAuth,
      headers: {
        'Content-Type': 'application/json',
        'ID-Token': id_Token,
      },
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const rentToSam = async (rentData) => {
  try {
    const user = JSON.parse(localStorage.getItem('token'));
    const id_Token = safeLocalStorage.getItem('id_Token');
    const resp = await axiosApi({
      method: 'patch',
      url: `/owners/rent_to_sam`,
      headers: {
        'Content-Type': 'application/json',
        'ID-Token': id_Token,
      },
      data: rentData,
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const getCurrentRobotsfunCompetition = async () => {
  try {
    const resp = await axiosApi({
      url: `/robotsfun/scavenger_competitions/nearest_competition`,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const associateWalletWithUser = async ({ address }) => {
  const user = safeLocalStorage.getItem('token');
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/agents/associate_wallet`,
      data: { address },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
      }
    })
    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export const getWalletAuthMessage = async ({ walletAddress }) => {
  try {
    const resp = await axios.post(
      `${process.env.NEXT_PUBLIC_API_URL}/robotsfun/authentication/auth_message`,
      { wallet_address: walletAddress },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return resp.data;
  } catch (err) {
    console.error('Error getting auth message:', err);
    throw err;
  }
}

export const signInWithWallet = async ({ message, signature, walletAddress, blockchain = 'solana' }) => {
  try {
    const resp = await axios.post(
      `${process.env.NEXT_PUBLIC_API_URL}/robotsfun/authentication/sign_in_wallet`,
      {
        message,
        signature,
        wallet_address: walletAddress,
        blockchain
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return resp.data;
  } catch (err) {
    console.error('Error signing in with wallet:', err);
    throw err;
  }
}

export const getUserWallets = async () => {
  const user = safeLocalStorage.getItem('token');
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/users/me/wallets`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
      }
    });
    return resp.data;
  } catch (err) {
    console.error('Error getting user wallets:', err);
    throw err;
  }
}


export const associateBotWithAgent = async ({ botSlug, agentId }) => {
  const user = safeLocalStorage.getItem('token');
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/agents/${agentId}/associate_bot`,
      data: { bot_slug: botSlug },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
      }
    })
    return resp.data;
  } catch (err) {
    console.error(err);
  }
}

export const frodoPointActivities = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('token'));
    const id_Token = safeLocalStorage.getItem('id_Token');
    const resp = await axiosApi({
      method: 'get',
      url: `/users/me/frodo_point_activities`,
      headers: {
        'Content-Type': 'application/json',
        'ID-Token': id_Token,
      },
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const samRentingSessions = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('token'));
    const id_Token = safeLocalStorage.getItem('id_Token');
    const resp = await axiosApi({
      method: 'get',
      url: `/users/me/sam_renting_sessions`,
      headers: {
        'Content-Type': 'application/json',
        'ID-Token': id_Token,
      },
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const getMyRobotsfunCompetition = async () => {
  try {
    const resp = await axiosApi({
      url: `/scavenger_drops/upcoming_competitions`,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const getTournamentBots = async () => {
  try {
    const res = await axiosApi({
      method: 'get',
      url: `/bots/competition_bots`,
    })
    return res.data;
  } catch (err) {
    console.log('err: ', err);
  }
}

export const getMultipleCompetitions = async () => {
  try {
    const resp = await axiosApi({
      url: `/multiple_competitions`,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const registerParticipant = async (data) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/multiple_competitions/${data.multiple_competition_id}/join`,
      data: data
    })

    return resp?.data
  } catch (err) {
    console.error(err);
  }
}

export const createTournament = async (tournamentData) => {
  try {
    const resp = await axiosApi({
      method: 'post',
      url: `/user_created_tournaments`,
      data: tournamentData,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return resp.data
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const robotsfunGetUsers = async (search = '') => {
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/users/find_by_username?username=${search}`,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    // New endpoint returns single user by exact match, wrap in array for compatibility
    const user = resp?.data?.data?.user;
    return user ? [user] : []
  } catch (err) {
    console.error('Error fetching users:', err);
    return [];
  }
}

export const getOwnerAssetsBots = async () => {
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/owners/assets_bots`,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return resp?.data
  } catch (err) {
    console.error('Error fetching owner bots:', err);
    return { bots: [] };
  }
}

export const getBotGameMaps = async (botId) => {
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/game_maps/bot_game_maps?bot_id=${botId}`,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return resp?.data
  } catch (err) {
    console.error('Error fetching bot game maps:', err);
    return [];
  }
}

export const getScore = async () => {
  try {
    const resp = await axiosApi({
      method: 'get',
      url: `/multiple_competitions/score`,
    })
    return resp?.data
  } catch (err) {
    console.error(err);
  }
}

export const fetchGeofences = async ({ botSlug }) => {
  try {
    const resp = await axiosApi({
      url: `/geofences/bot_geofences?bot_id=${botSlug}`,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp.data;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const createGeofences = async ({ data }) => {
  try {
    const resp = await axiosApi({
      url: '/geofences',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const deleteGeofence = async ({ id }) => {
  try {
    const resp = await axiosApi({
      url: `/geofences/${id}`,
      method: 'delete',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response;
    }
  }
}

export const updateGeofences = async ({ data, id }) => {
  try {
    const resp = await axiosApi({
      url: `/geofences/${id}`,
      method: 'patch',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const createGameMap = async ({ data }) => {
  try {
    const resp = await axiosApi({
      url: '/game_maps',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const updateGameMap = async ({ data, id }) => {
  try {
    const resp = await axiosApi({
      url: `/game_maps/${id}`,
      method: 'patch',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const fetchGameMaps = async ({ botId }) => {
  try {
    const resp = await axiosApi({
      url: `/game_maps/bot_game_maps?bot_id=${botId}`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const deleteGameMap = async ({ id }) => {
  try {
    const resp = await axiosApi({
      url: `/game_maps/${id}`,
      method: 'delete',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}

export const writeRideMetadata = async ({ rideId, data }) => {
  try {
    const resp = await axiosApi({
      url: `/rides/${rideId}/write_data`,
      method: 'post',
      data: { data },
    })
    return resp;
  } catch (err) {
    if (err.response) {
      return err.response.data
    }
  }
}
